export const stringToHash = (value?: string) => {
  if (!value) {
    return 0;
  }

  return value.split('').reduce(
    (prevHash, currVal) =>
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
    0,
  );
};
